import { CONSULTATION_TYPE, SUBJECT_TYPE } from 'src/constants';

export const SUBJECTS_LIST = [
    { id: SUBJECT_TYPE.NORMAL, name: 'Навчальний Предмет' },
    { id: SUBJECT_TYPE.FOREIGN, name: 'Іноземна мова' },
    { id: SUBJECT_TYPE.PSYCHOLOGY, name: 'Освітня послуга (психологія)' }
];

export const CONSULTATION_TYPE_LIST = [
    { id: CONSULTATION_TYPE.WITH_PUPILS, name: 'Консультація з учнями' },
    { id: CONSULTATION_TYPE.WITH_REPRESENTATIVES, name: 'Консультація з законними представниками дитини' },
    { id: CONSULTATION_TYPE.WITH_EMPLOYEES, name: 'Консультація з педагогічними працівниками' }
];

export const CONSULTATION_DURATION = [
    { id: 20, name: '20 хв' },
    { id: 30, name: '30 хв' },
    { id: 40, name: '40 хв' },
    { id: 50, name: '50 хв' },
    { id: 60, name: '60 хв' },
    { id: 70, name: '70 хв' },
    { id: 80, name: '80 хв' },
    { id: 90, name: '90 хв' },
    { id: 100, name: '100 хв' },
    { id: 110, name: '110 хв' },
    { id: 120, name: '120 хв' }
];
